<template>
  <div class="inbox-filter">
    <input v-model="inbox.filter['searchterm']" placeholder="search infobit" @keyup.enter="searchInbox">
    <div class="drop-down-filters">
      <user-select :model="inbox.filter" prop="username" :add-all-option="true"></user-select>
      <type-select></type-select>
    </div>
    <div id="startDate">
      <datepicker v-model="filter.startDate" placeholder="start date"></datepicker>
      <span class="fa fa-times fa-fw clickable" @click="resetStartDateFilter"></span>
    </div>
    <div id="endDate">
      <datepicker v-model="filter.endDate" placeholder="end date"></datepicker> 
      <span class="fa fa-fw fa-times clickable" @click="resetEndDateFilter"></span>
    </div>
  </div>
</template>

<script>
export default {

  components: {
    datepicker: require('vuejs-datepicker'),
    userSelect: require('./user-select.vue'),
    typeSelect: require('./inbox-type-select.vue')
  },

  computed: {

    filter () {
      return this.$store.state.inbox.filter
    },

    inbox () {
      return this.$store.state.inbox
    }
  },

  methods: {

    resetStartDateFilter () {
      this.$store.dispatch('resetStartDateFilter')
    },

    resetEndDateFilter () {
      this.$store.dispatch('resetEndDateFilter')
    },

    searchInbox () {
      this.$store.dispatch('searchInbox')
    }
  }
}
</script>

<style>
.inbox-filter .drop-down-filters {
  margin-top: 0.8em;
}

.inbox-filter #startDate input {
  margin-top: 0.8em;
}

.inbox-filter #endDate input {
  margin-top: 0.8em;
}

.inbox-filter .datepicker {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// inbox-filter.vue?440b9e2e